<template>
  <div class="wg-table">
    <div v-if="!rows.length" class="wg-problem">No rows.</div>
    <table v-else>
      <thead>
        <tr><th v-for="col in shown" :key="col.field">{{ col.header }}</th></tr>
      </thead>
      <tbody>
        <tr v-for="(row, i) in limited" :key="i" :class="{ link: linkField && row[linkField] != null }" @click="open(row)">
          <td v-for="col in shown" :key="col.field" class="sensitive" :class="{ num: isNumber(row[col.field]) }">
            {{ format(row[col.field]) }}
          </td>
        </tr>
      </tbody>
    </table>
    <div v-if="rows.length > limited.length" class="wg-more">{{ limited.length }} of {{ rows.length }} rows</div>
  </div>
</template>

<script>
export default {
  name: 'TableWidget',
  props: {
    inputs: { type: Object, default: () => ({}) },
    config: { type: Object, default: () => ({}) },
    width: { type: Number, default: 0 },
    height: { type: Number, default: 0 },
  },
  computed: {
    rows() {
      return (this.inputs.rows || {}).rows || [];
    },
    columns() {
      return (this.inputs.rows || {}).columns || Object.keys(this.rows[0] || {});
    },
    shown() {
      const wanted = Array.isArray(this.config.columns) && this.config.columns.length ? this.config.columns : null;
      if (wanted) {
        return wanted.map((c) => (typeof c === 'string' ? { field: c, header: c } : { field: c.field, header: c.header || c.field }));
      }
      return this.columns.map((c) => ({ field: c, header: c }));
    },
    linkField() {
      return this.config.link_entity_field || '';
    },
    limited() {
      const max = Number(this.config.max_rows) || 200;
      return this.rows.slice(0, max);
    },
  },
  methods: {
    open(row) {
      const id = this.linkField && row[this.linkField];
      if (id != null && id !== '') this.$router.push({ name: 'Entity', params: { entity_id: id } });
    },
    isNumber(v) {
      return typeof v === 'number';
    },
    format(v) {
      if (v === null || v === undefined) return '';
      if (typeof v === 'number') return Number.isInteger(v) ? v.toLocaleString() : v.toLocaleString(undefined, { maximumFractionDigits: 2 });
      return String(v);
    },
  },
};
</script>

<style scoped>
.wg-table { height: 100%; overflow: auto; font-size: 12.5px; }
table { border-collapse: collapse; width: 100%; }
th { position: sticky; top: 0; background: #faf9f6; text-align: left; font-weight: 600; color: #56534d; padding: 6px 10px; border-bottom: 1px solid #e6e4df; font-size: 11.5px; text-transform: uppercase; letter-spacing: 0.02em; }
td { padding: 5px 10px; border-bottom: 1px solid #f0efec; color: #1a1918; white-space: nowrap; }
td.num { text-align: right; font-variant-numeric: tabular-nums; }
tr.link { cursor: pointer; }
tr.link:hover td { background: #faf9f6; }
.wg-more { padding: 6px 10px; font-size: 11px; color: #8b877f; }
.wg-problem { padding: 16px; font-size: 12.5px; color: #8b877f; }
</style>
